import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { Link } from '@resy/ui-kitchen';
import { handleMktAnalytics } from '../AmexUtils';
import { CTA_EVENT_NAME } from '../constants';
import WrapperExperientialEventsCard from '../WrapperExperientialEventsCard';
import './AmexEventsComponent.scss';

const AmexEventsComponent = (props) => {
  const {
    baseRequestUrl,
    contentData = {},
    matchMedia,
    eventsAllData,
    getEventComponentStatus,
    componentCallback,
    Analytics,
  } = props;

  const requiredKeys = ['heading', 'content'];
  const requiredCtaKeys = ['label', 'link'];
  const hasAllKeys = requiredKeys
    .every((i) => Object.prototype.hasOwnProperty.call(contentData, i) && contentData[i] && Object.keys(contentData[i]).length !== 0);

  if (Object.keys(contentData).length === 0 || !hasAllKeys) {
    getEventComponentStatus(false);
    componentCallback('isEventsDataLoaded', true);
  }

  const {
    section_id: sectionId = '',
    heading,
    content = {},
  } = contentData;

  const {
    cta = {},
  } = content;
  const hasCtaKeys = requiredCtaKeys.every((i) => Object.prototype.hasOwnProperty.call(cta, i) && cta[i]);
  if (!hasCtaKeys) {
    getEventComponentStatus(false);
    componentCallback('isEventsDataLoaded', true);
  }

  const {
    label: ctaLabel,
    link: ctaLink,
  } = cta;

  const {
    eventsLoading,
    experientialEvents = [],
  } = eventsAllData;
  const [noEvents, setNoEvents] = useState(false);

  useEffect(() => {
    if (!eventsLoading && (!experientialEvents || experientialEvents.length === 0)) {
      setNoEvents(true);
      getEventComponentStatus(false);
    }
  }, [eventsAllData]);

  useEffect(() => {
    if (experientialEvents?.length > 0) componentCallback('isEventsDataLoaded', true);
  }, [experientialEvents?.length]);

  const renderSkeleton = () => {
    const cardSkeletonList = [];
    const cardSkeleton = (
      <li className="AmexExperientialEventsCard">
        <div className="AmexEventsComponent__skeleton-card">
          <div className="image skeleton" />
          <div className="calendar-icon" />
          <div className="info">
            <div className="soldout skeleton" />
            <div className="venue-name skeleton" />
            <div className="date skeleton" />
            <div className="date skeleton" />
            <div className="cta skeleton" />
          </div>
        </div>
      </li>
    );

    for (let i = 0; i < 5; i++) {
      cardSkeletonList.push(cardSkeleton);
    }

    return (
      <>
        {cardSkeletonList}
      </>
    );
  };

  const renderSectionsContent = () => (experientialEvents.map((eventItem) => {
    const propsAdded = {
      baseRequestUrl,
      taggingConfig: { ...content?.action_names },
      matchMedia,
      eventsContent: eventsAllData,
      isCarousel: false,
      eventItem,
      content,
      Analytics,
    };

    return (
      <WrapperExperientialEventsCard
        {...propsAdded}
      />
    );
  }));

  const renderContent = () => (
    <div className="AmexEventsComponent__wrapper">
      <ul
        className={cx('AmexEventsComponent__grid', {
          'centered-desktop': matchMedia.xl && (experientialEvents && experientialEvents.length < 5),
          'centered-tablet': matchMedia.md && (experientialEvents && experientialEvents.length < 3),
        })}
      >
        {eventsLoading && renderSkeleton()}
        {!eventsLoading && experientialEvents && renderSectionsContent()}
      </ul>
    </div>
  );

  if (noEvents) return null;

  const handleLinkClick = () => {
    const extraParam = { action_name: 'Events And Experiences - See All Events Click' };
    handleMktAnalytics(Analytics.event, CTA_EVENT_NAME, extraParam);
  };

  return (
    <section className="AmexEventsComponent">
      <div className="container">
        <div className="AmexEventsComponent__body">
          <h2
            id={sectionId}
            className="AmexEventsComponent__mainTitle"
          >
            {heading}
          </h2>
          {renderContent()}
          <p className="AmexEventsComponent__linkWrapper">
            <Link
              rel="noopener noreferrer"
              target="_blank"
              href={ctaLink}
              className="AmexEventsComponent__CTA"
              onContextMenu={() => handleLinkClick()}
              onClick={() => handleLinkClick()}
            >
              {ctaLabel}
            </Link>
          </p>
        </div>
      </div>
    </section>
  );
};

AmexEventsComponent.propTypes = {
  baseRequestUrl: PropTypes.string.isRequired,
  contentData: PropTypes.shape({
    section_id: PropTypes.string,
    heading: PropTypes.string,
    event_tag: PropTypes.string,
    cta: PropTypes.shape({
      label: PropTypes.string,
      link: PropTypes.string,
      action_name: PropTypes.string,
    }).isRequired,
    content: PropTypes.shape({
      events_event_tag: PropTypes.shape({}),
    }),
  }).isRequired,
  matchMedia: PropTypes.shape({
    xs: PropTypes.bool,
    sm: PropTypes.bool,
    md: PropTypes.bool,
    lg: PropTypes.bool,
    xl: PropTypes.bool,
  }).isRequired,
  eventsAllData: PropTypes.shape({
    experientialEvents: PropTypes.arrayOf(PropTypes.shape({})),
    eventsLoading: PropTypes.bool.isRequired,
  }).isRequired,
  getEventComponentStatus: PropTypes.func.isRequired,
  Analytics: PropTypes.shape({
    event: PropTypes.func,
  }).isRequired,
  pageName: PropTypes.string.isRequired,
  componentCallback: PropTypes.func,
};

AmexEventsComponent.defaultProps = {
  componentCallback: () => {},
};

export default AmexEventsComponent;
